import { render, staticRenderFns } from "./BlogFeeds.vue?vue&type=template&id=25f57aba&scoped=true"
import script from "./BlogFeeds.vue?vue&type=script&lang=js"
export * from "./BlogFeeds.vue?vue&type=script&lang=js"
import style0 from "./BlogFeeds.vue?vue&type=style&index=0&id=25f57aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f57aba",
  null
  
)

export default component.exports